export function setTitle(title) {
  const suffix = "Trihurst Tech |";
  document.title = `${suffix} ${title}`;
}